import { render, staticRenderFns } from "./PanelInputWrap.vue?vue&type=template&id=773507c0&"
import script from "./PanelInputWrap.vue?vue&type=script&lang=js&"
export * from "./PanelInputWrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('773507c0')) {
      api.createRecord('773507c0', component.options)
    } else {
      api.reload('773507c0', component.options)
    }
    module.hot.accept("./PanelInputWrap.vue?vue&type=template&id=773507c0&", function () {
      api.rerender('773507c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PanelInputWrap.vue"
export default component.exports